import _ from 'lodash';
import { DatePicker, Table, TableColumnsType } from 'antd';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../store/rootReducer';
import moment from 'moment';
//import useAuth from '../../../hooks/useAuth';
import useAxios from '../../../hooks/useAxios';
import useNotification from "../../../hooks/useNotification";
import SelectCampus from '../../../components/SelectCampus';
import SelectEduStep from '../../../components/SelectEduStep';
import Button from '../../../components/Button';
import Loader from '../../../components/Loader';
import { IPtStatsByGradeDetailReq, IPtStatsByGradeDetail, IGetPtStatsByGradeDetail } from '../../../models/statistics.model';
import { getPtStatsByGradeDetail } from '../../../api/statistics.api';
import exportTable from '../../../lib/exportTable';
import DownloadButton from '../../../components/DownloadButton';
import ErrorResponse from '../../../components/ErrorResponse';

const PtStatsByGradeDetail = () => {
    const { t, i18n } = useTranslation();
    const { currentCampus } = useSelector((state: RootState) => state.auth);
    const { campusData } = useSelector((state: RootState) => state.campusData);
    const { infoNotification } = useNotification();

    const [eduStepCode, setEduStepCode] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [excelCampus, setExcelCampus] = useState('');

    const { data: res, isLoading, error, execute } = useAxios<IGetPtStatsByGradeDetail>();
    const [data, setData] = useState<IPtStatsByGradeDetail[]>([]);

    const onSearch = () => {
        //const param: any = { page: 1 };
        //console.log(`startDate : ${startDate}, endDate : ${endDate}`);

        if (!startDate) {
            return infoNotification(t('statistics.placementTest.message2'));
          }
          if (!endDate) {
            return infoNotification(t('statistics.placementTest.message3'));
          }

        getGradeStat();
    }

    useEffect(() => {
        setStartDate(moment().add(-1, 'months').format('YYYYMMDD'));
        setEndDate(moment().format('YYYYMMDD'));
    }, [])

    useEffect(() => {
        if (res && !isLoading) {            
            // data filtering
            const data: IPtStatsByGradeDetail[] = _.cloneDeep(res.data);
            data.push(calculateTotal(res.data));
            
            setData(data);
        }
    }, [res, isLoading])

    const getGradeStat = () => {
        if (!currentCampus) return;

        const gradeStatParam : IPtStatsByGradeDetailReq = {
            campusCode: currentCampus,
            startDate: startDate,
            endDate: endDate,
            eduStepCode: eduStepCode === '' ? 'ALL' : eduStepCode
        }

        setExcelCampus(currentCampus);

        execute(getPtStatsByGradeDetail(gradeStatParam));
    }

    const getCampusName = (campusCode: string) => {
        if (!campusCode) return 'NO CAMPUS';
    
        const campus = campusData.find(item => item.campusCode === campusCode);
        return (
          i18n.language === 'ko' ? campus?.campusKorName : campus?.campusEngName
        );
    }

    const calculateTotal = (rawData: IPtStatsByGradeDetail[]) => {
        const total: IPtStatsByGradeDetail = {
            campusCode: '',
            campusName: '',
            campusEnglishName: '',
            gradeCode: '',
            gradeName: t('entrance.statistics.row1'),
            gradeEnglishName: '',
            applyCnt: 0,
            testCnt: 0,
            classCnt: 0,
            registCnt: 0,
            registRate: 0
        }
        
        rawData.forEach(item => {
          total.applyCnt += item.applyCnt;
          total.testCnt += item.testCnt;
          total.classCnt += item.classCnt;
          total.registCnt += item.registCnt;
        });
        
        if(total.registCnt === 0 || total.testCnt === 0) {
            total.registRate = 0;
        } else {
            total.registRate = Math.round(total.registCnt / total.testCnt * 100);
        }
    
        return total;
    };

    const onExportTable = () => {
        if (res && !isLoading) {
            const currentDate = moment(new Date());

            const _data: IPtStatsByGradeDetail[] = _.cloneDeep(data);

            _data.forEach(item => {
                item.registRate = item.registRate + '%'
            })

            exportTable(columns, _data, `${t('statistics.placementTest.title1')}_${t('entrance.schedule.tab2')}_${getCampusName(excelCampus)}_(${currentDate.format('YYYYMMDD')})`, t('entrance.schedule.tab2'), [15, 12, 10, 12, 12, 12, 12]);
        } else {
            return infoNotification(t('statistics.appday.text1'));
        }
    }

    const columns: TableColumnsType<IPtStatsByGradeDetail> = [
        {
            title: t('entrance.statistics.column1'),
            dataIndex: 'campusName',
            align: 'center',
            render: (value, record) => i18n.language === 'ko' ? value : record.campusEnglishName
        },
        {
            title: t('entrance.statistics.column2'),
            dataIndex: 'gradeName',
            align: 'center',
            render: (value, record) => i18n.language === 'ko' ? value : record.gradeEnglishName,
            sorter: (a, b) => {
                if(a.campusCode !== '') {
                    if(i18n.language === 'ko') {
                        return a.gradeName?.localeCompare(b.gradeName)
                    } else {
                        return a.gradeEnglishName?.localeCompare(b.gradeEnglishName);
                    }
                } else {
                    return 0;
                }
            }
        },
        {
            title: t('entrance.statistics.column3'),
            dataIndex: 'applyCnt',
            align: 'center',
            sorter: (a, b) => {
                if(a.campusCode !== '') {
                    return a.applyCnt-b.applyCnt
                } else {
                    return 0;
                }
            }
        },
        {
            title: t('entrance.statistics.column4'),
            dataIndex: 'testCnt',
            align: 'center',
            sorter: (a, b) => {
                if(a.campusCode !== '') {
                    return a.testCnt-b.testCnt
                } else {
                    return 0;
                }
            }
        },
        {
            title: t('entrance.statistics.column5'),
            dataIndex: 'classCnt',
            align: 'center',
            sorter: (a, b) => {
                if(a.campusCode !== '') {
                    return a.classCnt-b.classCnt
                } else {
                    return 0;
                }
            }
        },
        {
            title: t('entrance.statistics.column6'),
            dataIndex: 'registCnt',
            align: 'center',
            sorter: (a, b) => {
                if(a.campusCode !== '') {
                    return a.registCnt-b.registCnt
                } else {
                    return 0;
                }
            }
        },
        {
            title: t('entrance.statistics.column7'),
            dataIndex: 'registRate',
            align: 'center',
            render: value => value + '%',
            sorter: (a, b) => {
                if(a.campusCode !== '') {
                    return a.registRate-b.registRate
                } else {
                    return 0;
                }
            }
        }
    ]

    return(
        <>
            <div className="common-search">
                <div className="search-area">
                    <ul className="search-bx">
                        <li>
                            <label>{t('common.menu.campus')}</label> {/* 캠퍼스 */}
                            <div>
                                <SelectCampus />
                            </div>
                        </li>
                        <li>
                            <label>{t('common.placeholder.1')}</label> {/* 교육단계 */}
                            <SelectEduStep
                            eduStepCode={eduStepCode}
                            setEduStepCode={setEduStepCode}
                            includeAll
                            width={90}
                            />
                        </li>
                        <li>
                            <label>{t('sms.list.column1')}</label>{/* 기간 */}
                            <div className="date-picker__area">
                                <DatePicker
                                value={startDate ? moment(startDate) : undefined}
                                onChange={e => {
                                    if (e === null) setStartDate('');
                                    else setStartDate(moment(e).format('YYYYMMDD'))
                                }}
                                format={['YYYY-MM-DD', 'YYYYMMDD']}
                                />
                            </div>
                            ~
                            <div className="date-picker__area">
                                <DatePicker
                                value={endDate ? moment(endDate) : undefined}
                                onChange={e => {
                                    if (e === null) setEndDate('');
                                    else setEndDate(moment(e).format('YYYYMMDD'))
                                }}
                                format={['YYYY-MM-DD', 'YYYYMMDD']}
                                />
                            </div>
                            <div className="comm-btn__area">
                                <Button
                                    className="btn-basic small black"
                                    onClick={onSearch}
                                    text={t('common.button.search')}
                                />
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            {isLoading ? <Loader /> : null}
            {<ErrorResponse error={error} />}
            <div className="col-frame">
                <div className="comm-table__area">
                <Table
                    columns={columns}
                    dataSource={data}
                    pagination={{
                        current: 1,
                        pageSize: 100,
                    }}
                    rowClassName="pointer"
                    rowKey="gradeCode"
                />
                </div>
                <div className="comm-bx__between">
                    <DownloadButton onClick={onExportTable} />
                </div>
            </div>
        </>
    );
}

export default PtStatsByGradeDetail;